/**
 * @author Brendan Magee
 * @desc Component for card actions that display on hover over horizontal ellipsis
 * @example <hover-action-box
 *            update="$ctrl.update({ item: item})"
 *            update-label="UPDATE"
 *            delete="$ctrl.delete({ item: item })"
 *            delete-label="DELETE"
 *          >
 *          </hover-action-box>
 */

import template from './hoverActionBox.html';

const hoverActionBox = {
  template,
  restrict: 'E',
  bindings: {
    moveToTop: '&',
    moveToTopLabel: '@',
    moveToBottom: '&',
    moveToBottomLabel: '@',
    update: '&',
    updateLabel: '@',
    delete: '&',
    deleteLabel: '@',
    deleteAuthorized: '<'
  }
};

export default (ngModule) => {
  ngModule.component('hoverActionBox', hoverActionBox);
};
